/*
* @Author: babysoft08
* @Date:   2025-06-07 17:59:19
* @Last Modified by:   babysoft08
* @Last Modified time: 2025-06-07 18:48:14
*/
import React, { useCallback, useRef } from "react";
import { useDropzone } from "react-dropzone";
import "./DropZone.css";

const MAX_FILE_SIZE = 25 * 1024 * 1024;

const DropZone = ({ files, setFiles, fileErrors, setFileErrors }) => {
  const fileInputRef = useRef(null); // Reference for input field

  const onDrop = useCallback(
    (acceptedFiles, rejectedFiles) => {
      const validFiles = acceptedFiles.filter(file => {
        if (file.size > MAX_FILE_SIZE) {
          setFileErrors([...fileErrors,`File "${file.name}" exceeds the 25MB size limit.`])
          return false;
        }
        return true;
      });
      setFiles([...files, ...validFiles]);
    },
    [files, setFiles]
  );

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    multiple: true,
    accept: ".pdf,.doc,.docx,.jpg,.jpeg,.png,.tiff,.tif,.xlsx,.xls",
    noClick: true, // Prevents automatic file browser opening when clicking dropzone
  });

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click(); // Manually trigger file input
    }
  };

  return (
    <div className="dropzone-container">
      <div {...getRootProps({ className: "dropzone" })}>
        <input {...getInputProps()} ref={fileInputRef} />
        <div className="upload-icon">
        	<i className="fas fa-cloud-upload-alt" style={{ color: '#000' }}></i>
        </div>
        <p className="dropzone-text"><strong>Drag & drop files here</strong></p>
        <p className="or-text">OR</p>
        <button type="button" className="upload-button" onClick={handleButtonClick}>
          Click to upload
        </button>
        <p className="file-types">
          Supported: JPG, JPEG, PNG, TIFF, PDF, TIF, XLSX, XLS
        </p>
        <p className="file-types">
          File size should be a maximum 25 mb and it shouldn't be password protected.
        </p>
      </div>
    </div>
  );
};

export default DropZone;